import 'babel-polyfill'
import Vue from 'vue'
import ru from 'vee-validate/dist/locale/ru'
import VeeValidate, { Validator } from 'vee-validate'
import { DatePicker } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueRouter from 'vue-router'
import { store } from './store/store'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { routes } from './routes/routes'
import { sync } from 'vuex-router-sync'
import axios from 'axios'
import moment from 'moment'
import 'moment/locale/ru'
import Vue2Editor from 'vue2-editor'

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(DatePicker)
Vue.use(Vue2Editor)

Validator.localize('ru', ru)
moment.locale('ru')

Vue.use(VeeValidate, {
  locale: 'ru',
  inject: true,
  fieldsBagName: 'veeFields',
  errorBagName: 'veeErrors'
})

Vue.config.productionTip = false

const router = new VueRouter({
  routes: routes
})
const token = localStorage.getItem('token_citadel_authorization')
if (token) {
  axios.defaults.headers.common.Authorization = token
}
sync(store, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
